export default function initFormBlocks() {
    const blocks = [].slice.call(document.querySelectorAll('.themeFormset'));

    blocks.forEach(initFormBlock);
}

function initFormBlock(root) {
    const toggles = [].slice.call(root.querySelectorAll('input[name="form"]'));
    const forms = [].slice.call(root.querySelectorAll('.themeFormset-formWrapper'));

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const form = forms.find((f) => {
                return f.dataset.formId === toggle.value
            })

            forms.forEach(form => form.classList.remove('is-active'))
            form.classList.add('is-active');
        })
    })
}
